import type { Locale } from '@awj/i18n';

/**
 * The shop, as the browser reaches it. Compiled in like the API's address; it was written into
 * the link as `http://localhost:3000`, so in production "visit the shop" opened nothing.
 */
export const STOREFRONT_URL = import.meta.env.VITE_AWJ_STOREFRONT_URL ?? 'http://localhost:3000';

/** A page of the shop in one language — every storefront route starts with its locale. */
export function storefrontPage(locale: Locale, path: string): string {
  return `${STOREFRONT_URL}/${locale}${path === '/' ? '' : path}`;
}
